import React, { useEffect, useRef, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useNavigate } from 'react-router-dom';
import {MdOutlineCircle, MdCreate , MdBlock, MdKeyboardArrowRight, MdKeyboardArrowLeft, MdAdd} from "react-icons/md";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaEye } from "react-icons/fa6"; 
import _constantUtil from '../../utils/Constant'   
import { Tooltip } from 'react-tooltip'


function AllTournament() {
  const navigate = useNavigate() 
  const [page, setPage] = useState(_constantUtil.ONE); 
  const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 

  const confirmationRef = useRef(_constantUtil.NULL); 
  useEffect(() => { 
    const handleClickOutside = (event) => {
      if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
        setShowConfirmation(_constantUtil.BOOLEAN_FALSE); 
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };    
  }, [page]);
 
  return (
    <> 
        {showConfirmation && (
          <div>
            <div className='confirmation-overlay'></div>
            <div ref={confirmationRef} className='confirmation-dialog'>
              <p>Are you sure to update tournament status ?</p>
              <div className='d-flex justify-content-end '>
                <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
                <button className='border-0 rounded px-3 bg-success text-white p-2 me-0'> Confirm </button>
              </div>
            </div>
          </div>
        )} 
        <div className='px-4 mt-4'>
            <div className='container-fluid p-0'>
                <div className='row'>
                    <h4 className='header-title pb-3 text-muted'>All Tournament</h4>
                        <div className='col-12'>
                            <div className='card'>
                                <div className='card-body'>

                                    <div className='d-flex justify-content-end align-items-center'>
                                        <div className=''>
                                            <button
                                                type='button'
                                                className='btn text-white d-flex align-items-center'
                                                onClick={() => navigate('/tournament/add-tournament')}>
                                                <MdAdd className='fs-5 me-1 mb-1 ' />
                                                Add
                                            </button>
                                        </div>
                                    </div>

                                    <div className='table-responsive'>
                                        <table className='table w-100 ' >
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Name</th>
                                                    <th >Format & Country</th>
                                                    <th>Upcoming</th>
                                                    <th>Launched</th>
                                                    <th>Live</th>
                                                    <th>Completed</th>
                                                    <th>Abondoned</th>
                                                    <th >Tournament Type</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr >
                                                    <th scope='row'>1</th> 
                                                    <td >Premier League <br /> ( English Premier League - EPL)</td>
                                                    <td >Domestic league<br /> ( England  )</td>
                                                    <td>
                                                      <FaRegCalendarAlt  
                                                        data-tooltip-id='upcomingmatch' data-tooltip-content="Match"
                                                        className=' jumbo-icon me-2 fs-5'
                                                        style={{ cursor: 'pointer',  }}
                                                        onClick={() => navigate('/match/all-upcoming')} 
                                                      />
                                                      <Tooltip id='upcomingmatch' place="bottom" effect="solid"/></td>
                                                    <td>
                                                      <span className='badge badge-secondary-lighten' style={{ cursor: 'pointer'}}  
                                                        data-tooltip-id='launchmatch' data-tooltip-content="Match"
                                                        onClick={() => navigate('/match/all-launch')} 
                                                        >1
                                                      </span>
                                                      <Tooltip id='launchmatch' place="bottom" effect="solid"/>
                                                    </td>
                                                    <td>
                                                      <span className='badge badge-info-lighten' 
                                                        onClick={() => navigate('/match/all-live')} 
                                                         style={{ cursor: 'pointer'}}>
                                                         0
                                                      </span>
                                                      </td>
                                                    <td>
                                                      <span className='badge badge-success-lighten'
                                                        onClick={() => navigate('/match/all-completed')} 
                                                        style={{ cursor: 'pointer'}}>
                                                        0
                                                      </span>
                                                      </td>
                                                    <td>
                                                      <span className='badge badge-danger-lighten' style={{ cursor: 'pointer'}}  
                                                        onClick={() => navigate('/match/all-abondoned')} 
                                                      >
                                                        0
                                                      </span>
                                                      </td>
                                                    <td>men<br /> ( Club )</td>
                                                    <td> 
                                                        <span className='badge badge-success-lighten'>
                                                          ACTIVE
                                                        </span> 
                                                    </td>
                                                    <td>
                                                      <div className='d-flex align-items-center justify-content-center'>
                                                        <MdCreate
                                                          data-tooltip-id='updateleague' data-tooltip-content="Update Tournament"
                                                          className=' jumbo-icon me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                          onClick={() => navigate(`/tournament/update-tournament`)}
                                                        />
                                                        <Tooltip id='Viea League' place="bottom" effect="solid"/>
                                                          <FaEye 
                                                            data-tooltip-id='Viea League' data-tooltip-content="View Tournament"
                                                            className=' jumbo-icon me-2 fs-5 text-primary'
                                                            style={{ cursor: 'pointer'}}
                                                            onClick={() => navigate(`/tournament/view-tournament`)} 
                                                          />
                                                          <Tooltip id='updateleague' place="bottom" effect="solid"/>
                                                                        
                                                          <MdBlock
                                                            data-tooltip-id='inactive' data-tooltip-content="Inactive Tournament"
                                                            className=' jumbo-icon pointer text-danger user-status fs-5 me-2' style={{cursor: 'pointer'}}   
                                                            onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                          />
                                                          <Tooltip id='inactive' place="bottom" effect="solid"/>   
                                                            <MdOutlineCircle
                                                              data-tooltip-id='active' data-tooltip-content="Active Tournament"
                                                              className=' jumbo-icon pointer text-success user-status fs-5 me-2' style={{cursor: 'pointer'}}   
                                                              onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                            /> 
                                                          <Tooltip id='active' place="bottom" effect="solid"/>      
                                                      </div>  
                                                    </td>
                                                </tr> 
                                            </tbody>
                                        </table>    
                                    </div>

                                    <ReactPaginate
                                        className='pagination'
                                        onPageChange={page => { setPage(page.selected + _constantUtil.ONE) }} 
                                        previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                                        nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={1}
                                        breakLabel={'..'}
                                        containerClassName={'pagination-container'}
                                        activeClassName={'pagination-active-page'}
                                    /> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default AllTournament
